export var ColonistMembershipPerkType = /*#__PURE__*/ function(ColonistMembershipPerkType) {
    ColonistMembershipPerkType[ColonistMembershipPerkType["AllMaps"] = 0] = "AllMaps";
    ColonistMembershipPerkType[ColonistMembershipPerkType["AllExpansions"] = 1] = "AllExpansions";
    ColonistMembershipPerkType[ColonistMembershipPerkType["PremiumMatchmaking"] = 2] = "PremiumMatchmaking";
    ColonistMembershipPerkType[ColonistMembershipPerkType["CustomLinks"] = 3] = "CustomLinks";
    ColonistMembershipPerkType[ColonistMembershipPerkType["ColonistCoins"] = 4] = "ColonistCoins";
    ColonistMembershipPerkType[ColonistMembershipPerkType["NoAds"] = 5] = "NoAds";
    ColonistMembershipPerkType[ColonistMembershipPerkType["AllColors"] = 6] = "AllColors";
    ColonistMembershipPerkType[ColonistMembershipPerkType["BasicReplay"] = 7] = "BasicReplay";
    ColonistMembershipPerkType[ColonistMembershipPerkType["FullReplay"] = 8] = "FullReplay";
    return ColonistMembershipPerkType;
}({});
